var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.mounted
    ? _c(
        "div",
        { staticClass: "application-page skills" },
        [
          _c(
            "b-container",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "3" } },
                    [_c("Navigation", { attrs: { page: "skills" } })],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { md: "9" } },
                    [
                      _c(
                        "div",
                        {
                          directives: [{ name: "sticky", rawName: "v-sticky" }],
                          staticClass: "sticky-title"
                        },
                        [_c("h1", [_vm._v("Meine Skills")])]
                      ),
                      _vm._v(" "),
                      _c("JonInfo", {
                        staticClass: "mb-5",
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "message",
                              fn: function() {
                                return [
                                  _vm._v(
                                    "\n\t\t\t\t\t\tDurch die vollständige Eingabe aller deiner Kompetenzen kannst du deine Chancen erhöhen!\n\t\t\t\t\t"
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          false,
                          1438183307
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          class: [
                            "main-content",
                            "profile-view",
                            { "loading-blockade": _vm.reloading }
                          ]
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "tag-sections" },
                            [
                              _c(
                                "section",
                                [
                                  _c("Title", {
                                    attrs: {
                                      title: "Softwarekompetenzen",
                                      parent: "",
                                      editable: false,
                                      "completion-type": _vm.getSectionsCompletionType(
                                        [
                                          _vm.sections.skillsSoftwareMain,
                                          _vm.sections.skillsSoftwareSpecial
                                        ]
                                      )
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "sub-sections" },
                                    [
                                      _vm.isSectionEligible(
                                        _vm.sections.skillsSoftwareMain
                                      )
                                        ? _c(
                                            "div",
                                            { staticClass: "sub-section" },
                                            [
                                              _c("Title", {
                                                attrs: {
                                                  title: "Bürosoftware",
                                                  "completion-type": _vm.getSectionCompletionType(
                                                    _vm.sections
                                                      .skillsSoftwareMain
                                                  )
                                                },
                                                on: {
                                                  edit: function($event) {
                                                    return _vm.$refs.skillsSoftwareMain.openFan()
                                                  }
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("CharacteristicEdit", {
                                                ref: "skillsSoftwareMain",
                                                class: {
                                                  inline:
                                                    _vm.hasNoSkillsSoftwareMain
                                                },
                                                attrs: {
                                                  title: "Software",
                                                  "characteristic-items":
                                                    _vm.meta.skillSoftwareMain,
                                                  "characteristic-type":
                                                    _vm.meta
                                                      .skillSoftwareMainType,
                                                  "nothing-allowed": {
                                                    onlyOverall: true,
                                                    overall: {
                                                      text:
                                                        "Ich habe noch keine Erfahrung mit Bürosoftware",
                                                      inFan: true
                                                    }
                                                  },
                                                  "selected-items-config": {
                                                    styling:
                                                      _vm.selectedItemsStylingList
                                                  },
                                                  "with-self-assessment": "",
                                                  "with-edit-button": false,
                                                  "header-info":
                                                    _vm.headerInfoApplicationNoExperience,
                                                  "completion-check-config": {
                                                    enabled: true,
                                                    label: "Bürosoftware",
                                                    okButtonText:
                                                      "Keine weitere Erfahrung mit Bürosoftware",
                                                    popUpInfo:
                                                      _vm.completionCheckInfos
                                                        .softwareMain
                                                  }
                                                },
                                                on: {
                                                  finish:
                                                    _vm.saveSkillsSoftwareMain
                                                },
                                                model: {
                                                  value: _vm.skillsSoftwareMain,
                                                  callback: function($$v) {
                                                    _vm.skillsSoftwareMain = $$v
                                                  },
                                                  expression:
                                                    "skillsSoftwareMain"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.isSectionEligible(
                                        _vm.sections.skillsSoftwareSpecial
                                      )
                                        ? _c("SkillsSoftwareSpecial", {
                                            attrs: {
                                              meta: _vm.meta,
                                              "completion-type": _vm.getSectionCompletionType(
                                                _vm.sections
                                                  .skillsSoftwareSpecial
                                              )
                                            },
                                            on: {
                                              change:
                                                _vm.saveSkillsSoftwareSpecial
                                            },
                                            model: {
                                              value: _vm.skillsSoftwareSpecial,
                                              callback: function($$v) {
                                                _vm.skillsSoftwareSpecial = $$v
                                              },
                                              expression:
                                                "skillsSoftwareSpecial"
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.isSectionEligible(_vm.sections.languages)
                                ? _c("Languages", {
                                    attrs: {
                                      meta: _vm.meta,
                                      "completion-type": _vm.getSectionCompletionType(
                                        _vm.sections.languages
                                      )
                                    },
                                    on: { change: _vm.saveLanguages },
                                    model: {
                                      value: _vm.languages,
                                      callback: function($$v) {
                                        _vm.languages = $$v
                                      },
                                      expression: "languages"
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isSectionEligible(
                                _vm.sections.experienceFunction
                              )
                                ? _c(
                                    "section",
                                    [
                                      _c("Title", {
                                        attrs: {
                                          title: "Tätigkeitserfahrung",
                                          parent: "",
                                          "completion-type": _vm.getSectionCompletionType(
                                            _vm.sections.experienceFunction
                                          )
                                        },
                                        on: {
                                          edit: function($event) {
                                            return _vm.$refs.experienceFunctions.edit()
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("Experience", {
                                        ref: "experienceFunctions",
                                        attrs: {
                                          "initial-data":
                                            _vm.experienceFunctions,
                                          meta: _vm.meta,
                                          "characteristic-items":
                                            _vm.meta.function,
                                          "characteristic-type":
                                            _vm.meta.functionType,
                                          title:
                                            "Welche Tätigkeitserfahrungen hast du?",
                                          "nothing-overall-text":
                                            "Ich habe noch keine Tätigkeitserfahrungen",
                                          "experience-none-allowed": "",
                                          "with-keyword": "",
                                          "with-edit-button": false,
                                          "supplements-config": {
                                            nothingAllowed: false,
                                            types: _vm.functionSupplementTypes
                                          },
                                          "completion-check-config": {
                                            label: "Tätigkeitserfahrung",
                                            infoLabel: "Tätigkeitserfahrungen",
                                            okButtonText:
                                              "Keine weitere Tätigkeitserfahrung"
                                          },
                                          "search-config": {
                                            catalog:
                                              _vm.meta.searchCatalogFunction
                                          }
                                        },
                                        on: {
                                          finish: function($event) {
                                            return _vm.saveExperience(
                                              $event,
                                              true,
                                              "experienceFunction",
                                              _vm.sections.experienceFunction
                                            )
                                          }
                                        },
                                        model: {
                                          value: _vm.experienceFunctions,
                                          callback: function($$v) {
                                            _vm.experienceFunctions = $$v
                                          },
                                          expression: "experienceFunctions"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isSectionEligible(
                                _vm.sections.experienceCareerLevel
                              )
                                ? _c(
                                    "section",
                                    [
                                      _c("Title", {
                                        attrs: {
                                          title: "Berufsebenen-Erfahrung",
                                          parent: "",
                                          "completion-type": _vm.getSectionCompletionType(
                                            _vm.sections.experienceCareerLevel
                                          )
                                        },
                                        on: {
                                          edit: function($event) {
                                            return _vm.$refs.experienceCareerLevels.edit()
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("Experience", {
                                        ref: "experienceCareerLevels",
                                        attrs: {
                                          "initial-data":
                                            _vm.experienceCareerLevels,
                                          meta: _vm.meta,
                                          "characteristic-items":
                                            _vm.meta.careerLevel,
                                          "characteristic-type":
                                            _vm.meta.careerLevelType,
                                          title:
                                            "Welche Berufsebenen-Erfahrung hast du?",
                                          "nothing-overall-text":
                                            "Ich habe noch keine Erfahrung",
                                          "experience-none-allowed": "",
                                          "with-keyword": false,
                                          "with-edit-button": false,
                                          "group-by-letter": {
                                            enabled: false
                                          },
                                          "completion-check-config": {
                                            label: "Berufsebenen-Erfahrung",
                                            infoLabel:
                                              "Berufsebenen-Erfahrungen",
                                            okButtonText:
                                              "Keine weitere Berufsebenen-Erfahrung"
                                          }
                                        },
                                        on: {
                                          finish: function($event) {
                                            return _vm.saveExperience(
                                              $event,
                                              false,
                                              "experienceCareerLevel",
                                              _vm.sections.experienceCareerLevel
                                            )
                                          }
                                        },
                                        model: {
                                          value: _vm.experienceCareerLevels,
                                          callback: function($$v) {
                                            _vm.experienceCareerLevels = $$v
                                          },
                                          expression: "experienceCareerLevels"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isSectionEligible(
                                _vm.sections.experienceIndustrialSector
                              )
                                ? _c(
                                    "section",
                                    [
                                      _c("Title", {
                                        attrs: {
                                          title:
                                            "Branchenerfahrung (Branchen, Leistungen, Produkte)",
                                          parent: "",
                                          "completion-type": _vm.getSectionCompletionType(
                                            _vm.sections
                                              .experienceIndustrialSector
                                          )
                                        },
                                        on: {
                                          edit: function($event) {
                                            return _vm.$refs.experienceIndustrialSectors.edit()
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("Experience", {
                                        ref: "experienceIndustrialSectors",
                                        attrs: {
                                          "initial-data":
                                            _vm.experienceIndustrialSectors,
                                          meta: _vm.meta,
                                          "characteristic-items":
                                            _vm.meta.industrialSector,
                                          "characteristic-type":
                                            _vm.meta.industrialSectorType,
                                          title:
                                            "In welchen Branchen oder mit welchen Leistungen und Produkten hast du Erfahrung?",
                                          "nothing-overall-text":
                                            "Ich habe noch keine Vorerfahrung in bestimmten Branchen",
                                          "experience-none-allowed": "",
                                          "with-keyword": "",
                                          "with-edit-button": false,
                                          "completion-check-config": {
                                            label: "Branchenerfahrung",
                                            infoLabel: "Branchenerfahrungen",
                                            okButtonText:
                                              "Keine weitere Branchenerfahrung"
                                          },
                                          "search-config": {
                                            catalog:
                                              _vm.meta
                                                .searchCatalogIndustrialSector
                                          }
                                        },
                                        on: {
                                          finish: function($event) {
                                            return _vm.saveExperience(
                                              $event,
                                              true,
                                              "experienceIndustrialSector",
                                              _vm.sections
                                                .experienceIndustrialSector
                                            )
                                          }
                                        },
                                        model: {
                                          value:
                                            _vm.experienceIndustrialSectors,
                                          callback: function($$v) {
                                            _vm.experienceIndustrialSectors = $$v
                                          },
                                          expression:
                                            "experienceIndustrialSectors"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isSectionEligible(
                                _vm.sections.experienceOrganisationalArea
                              )
                                ? _c(
                                    "section",
                                    [
                                      _c("Title", {
                                        attrs: {
                                          title:
                                            "Organisationsbereich-Erfahrung",
                                          parent: "",
                                          "completion-type": _vm.getSectionCompletionType(
                                            _vm.sections
                                              .experienceOrganisationalArea
                                          )
                                        },
                                        on: {
                                          edit: function($event) {
                                            return _vm.$refs.experienceOrganisationalArea.edit()
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("Experience", {
                                        ref: "experienceOrganisationalArea",
                                        attrs: {
                                          "initial-data":
                                            _vm.experienceOrganisationalArea,
                                          meta: _vm.meta,
                                          "characteristic-items":
                                            _vm.meta.organisationalArea,
                                          "characteristic-type":
                                            _vm.meta.organisationalAreaType,
                                          title:
                                            "In welchen Organisationsbereichen hast du Erfahrung?",
                                          "nothing-overall-text":
                                            "Ich habe noch keine Vorerfahrung in bestimmten Organisationsbereichen",
                                          "experience-none-allowed": "",
                                          "with-keyword": "",
                                          "with-edit-button": false,
                                          "completion-check-config": {
                                            label:
                                              "Organisationsbereich-Erfahrung",
                                            infoLabel:
                                              "Organisationsbereich-Erfahrungen",
                                            okButtonText:
                                              "Keine weitere Organisationsbereich-Erfahrungen"
                                          }
                                        },
                                        on: {
                                          finish: function($event) {
                                            return _vm.saveExperience(
                                              $event,
                                              true,
                                              "experienceOrganisationalArea",
                                              _vm.sections
                                                .experienceOrganisationalArea
                                            )
                                          }
                                        },
                                        model: {
                                          value:
                                            _vm.experienceOrganisationalArea,
                                          callback: function($$v) {
                                            _vm.experienceOrganisationalArea = $$v
                                          },
                                          expression:
                                            "experienceOrganisationalArea"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isSectionEligible(
                                _vm.sections.experienceManagement
                              )
                                ? _c(
                                    "section",
                                    [
                                      _c("Title", {
                                        attrs: {
                                          title:
                                            "Führungsverantwortung - Erfahrung",
                                          parent: "",
                                          "completion-type": _vm.getSectionCompletionType(
                                            _vm.sections.experienceManagement
                                          )
                                        },
                                        on: {
                                          edit: function($event) {
                                            return _vm.$refs.experienceManagement.edit()
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("Experience", {
                                        ref: "experienceManagement",
                                        attrs: {
                                          "initial-data":
                                            _vm.experienceManagement,
                                          meta: _vm.meta,
                                          "characteristic-items":
                                            _vm.meta.managementKind,
                                          "characteristic-type":
                                            _vm.meta.managementKindType,
                                          title:
                                            "Erfahrung mit Führungsverantwortung",
                                          "nothing-overall-text":
                                            "Ich habe noch keine Vorerfahrung mit Führungsverantwortung",
                                          "experience-none-allowed": "",
                                          "with-keyword": false,
                                          "with-edit-button": false,
                                          "completion-check-config": {
                                            label:
                                              "Erfahrung mit Führungsverantwortung",
                                            infoLabel: "Führungserfahrungen",
                                            okButtonText:
                                              "Keine weitere Führungserfahrung"
                                          }
                                        },
                                        on: {
                                          finish: function($event) {
                                            return _vm.saveExperience(
                                              $event,
                                              false,
                                              "experienceManagement",
                                              _vm.sections.experienceManagement
                                            )
                                          }
                                        },
                                        model: {
                                          value: _vm.experienceManagement,
                                          callback: function($$v) {
                                            _vm.experienceManagement = $$v
                                          },
                                          expression: "experienceManagement"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isSectionEligible(
                                _vm.sections.experienceCustomerContact
                              )
                                ? _c(
                                    "section",
                                    [
                                      _c("Title", {
                                        attrs: {
                                          title:
                                            "Erfahrung im Kontakt mit externen Personen / Kunden",
                                          tooltip:
                                            "Externe Personen sind zB Klienten, Kunden, Patienten, Interessenten, Bürger und andere",
                                          parent: "",
                                          "completion-type": _vm.getSectionCompletionType(
                                            _vm.sections
                                              .experienceCustomerContact
                                          )
                                        },
                                        on: {
                                          edit: function($event) {
                                            return _vm.$refs.experienceCustomerContact.edit()
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("Experience", {
                                        ref: "experienceCustomerContact",
                                        attrs: {
                                          "initial-data":
                                            _vm.experienceCustomerContact,
                                          meta: _vm.meta,
                                          "characteristic-items":
                                            _vm.meta.businessModel,
                                          "characteristic-type":
                                            _vm.meta.businessModelType,
                                          "experience-none-allowed": "",
                                          title:
                                            "Erfahrung im Kontakt mit externen Personen, wie Kunden, Klienten, Patienten, Interessenten, Bürger und andere",
                                          "nothing-overall-text":
                                            "Ich habe noch keine Vorerfahrung",
                                          "with-keyword": false,
                                          "with-edit-button": false,
                                          "completion-check-config": {
                                            label:
                                              "Erfahrung im Kontakt mit externen Personen",
                                            infoLabel: "Erfahrungen",
                                            okButtonText:
                                              "Keine weitere Erfahrung"
                                          }
                                        },
                                        on: {
                                          finish: function($event) {
                                            return _vm.saveExperience(
                                              $event,
                                              false,
                                              "experienceCustomerContact",
                                              _vm.sections
                                                .experienceCustomerContact
                                            )
                                          }
                                        },
                                        model: {
                                          value: _vm.experienceCustomerContact,
                                          callback: function($$v) {
                                            _vm.experienceCustomerContact = $$v
                                          },
                                          expression:
                                            "experienceCustomerContact"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isSectionEligible(
                                _vm.sections.experienceFunctionMarketingRole
                              )
                                ? _c(
                                    "section",
                                    [
                                      _c("Title", {
                                        attrs: {
                                          title:
                                            "Marketingtätigkeiten - Erfahrung",
                                          parent: "",
                                          "completion-type": _vm.getSectionCompletionType(
                                            _vm.sections
                                              .experienceFunctionMarketingRole
                                          )
                                        },
                                        on: {
                                          edit: function($event) {
                                            return _vm.$refs.experienceFunctionMarketingRole.edit()
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("Experience", {
                                        ref: "experienceFunctionMarketingRole",
                                        attrs: {
                                          "initial-data":
                                            _vm.experienceFunctionMarketingRole,
                                          meta: _vm.meta,
                                          "characteristic-items":
                                            _vm.meta.functionMarketingRole,
                                          "characteristic-type":
                                            _vm.meta.functionMarketingRoleType,
                                          title:
                                            "Hast du mit bestimmten Marketingtätigkeiten Erfahrung gesammelt?",
                                          "nothing-overall-text":
                                            "Ich habe noch keine Vorerfahrung",
                                          "with-keyword": false,
                                          "with-experience": true,
                                          "with-edit-button": false,
                                          "completion-check-config": {
                                            label:
                                              "Marketingtätigkeiten - Erfahrung",
                                            infoLabel:
                                              "Marketingtätigkeits-Erfahrungen",
                                            okButtonText:
                                              "Keine weitere Marketingerfahrung"
                                          }
                                        },
                                        on: {
                                          finish: function($event) {
                                            return _vm.saveExperience(
                                              $event,
                                              false,
                                              "experienceFunctionMarketingRole",
                                              _vm.sections
                                                .experienceFunctionMarketingRole
                                            )
                                          }
                                        },
                                        model: {
                                          value:
                                            _vm.experienceFunctionMarketingRole,
                                          callback: function($$v) {
                                            _vm.experienceFunctionMarketingRole = $$v
                                          },
                                          expression:
                                            "experienceFunctionMarketingRole"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isSectionEligible(
                                _vm.sections.experienceFunctionLegalField
                              )
                                ? _c(
                                    "section",
                                    [
                                      _c("Title", {
                                        attrs: {
                                          title: "Rechtsgebiete - Erfahrung",
                                          parent: "",
                                          "completion-type": _vm.getSectionCompletionType(
                                            _vm.sections
                                              .experienceFunctionLegalField
                                          )
                                        },
                                        on: {
                                          edit: function($event) {
                                            return _vm.$refs.experienceFunctionLegalField.edit()
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("Experience", {
                                        ref: "experienceFunctionLegalField",
                                        attrs: {
                                          "initial-data":
                                            _vm.experienceFunctionLegalField,
                                          meta: _vm.meta,
                                          "characteristic-items":
                                            _vm.meta.functionLegalField,
                                          "characteristic-type":
                                            _vm.meta.functionLegalFieldType,
                                          title:
                                            "Hast du mit bestimmten Rechtsgebieten Erfahrung gesammelt?",
                                          "nothing-overall-text":
                                            "Ich habe noch keine Vorerfahrung",
                                          "experience-none-allowed": "",
                                          "with-keyword": false,
                                          "with-edit-button": false,
                                          "completion-check-config": {
                                            label: "Rechtsgebiete - Erfahrung",
                                            infoLabel:
                                              "Rechtsgebiets-Erfahrungen",
                                            okButtonText:
                                              "Keine weitere Rechtsgebiete-Erfahrung"
                                          }
                                        },
                                        on: {
                                          finish: function($event) {
                                            return _vm.saveExperience(
                                              $event,
                                              false,
                                              "experienceFunctionLegalField",
                                              _vm.sections
                                                .experienceFunctionLegalField
                                            )
                                          }
                                        },
                                        model: {
                                          value:
                                            _vm.experienceFunctionLegalField,
                                          callback: function($$v) {
                                            _vm.experienceFunctionLegalField = $$v
                                          },
                                          expression:
                                            "experienceFunctionLegalField"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isSectionEligible(
                                _vm.sections.experienceFunctionLegalRole
                              )
                                ? _c(
                                    "section",
                                    [
                                      _c("Title", {
                                        attrs: {
                                          title:
                                            "Rechtstätigkeiten - Erfahrung",
                                          parent: "",
                                          "completion-type": _vm.getSectionCompletionType(
                                            _vm.sections
                                              .experienceFunctionLegalRole
                                          )
                                        },
                                        on: {
                                          edit: function($event) {
                                            return _vm.$refs.experienceFunctionLegalRole.edit()
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("Experience", {
                                        ref: "experienceFunctionLegalRole",
                                        attrs: {
                                          "initial-data":
                                            _vm.experienceFunctionLegalRole,
                                          meta: _vm.meta,
                                          "characteristic-items":
                                            _vm.meta.functionLegalRole,
                                          "characteristic-type":
                                            _vm.meta.functionLegalRoleType,
                                          title:
                                            "Hast du mit bestimmten Rechtstätigkeiten Erfahrung gesammelt?",
                                          "nothing-overall-text":
                                            "Ich habe noch keine Vorerfahrung",
                                          "with-experience": true,
                                          "with-keyword": false,
                                          "with-edit-button": false,
                                          "completion-check-config": {
                                            label:
                                              "Rechtstätigkeiten - Erfahrung",
                                            infoLabel:
                                              "Rechtstätigkeits-Erfahrungen",
                                            okButtonText:
                                              "Keine weitere Rechtstätigkeits-Erfahrung"
                                          }
                                        },
                                        on: {
                                          finish: function($event) {
                                            return _vm.saveExperience(
                                              $event,
                                              false,
                                              "experienceFunctionLegalRole",
                                              _vm.sections
                                                .experienceFunctionLegalRole
                                            )
                                          }
                                        },
                                        model: {
                                          value:
                                            _vm.experienceFunctionLegalRole,
                                          callback: function($$v) {
                                            _vm.experienceFunctionLegalRole = $$v
                                          },
                                          expression:
                                            "experienceFunctionLegalRole"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isSectionEligible(
                                _vm.sections.experienceFunctionTaxField
                              )
                                ? _c(
                                    "section",
                                    [
                                      _c("Title", {
                                        attrs: {
                                          title: "Steuergebiete - Erfahrung",
                                          parent: "",
                                          "completion-type": _vm.getSectionCompletionType(
                                            _vm.sections
                                              .experienceFunctionTaxField
                                          )
                                        },
                                        on: {
                                          edit: function($event) {
                                            return _vm.$refs.experienceFunctionTaxField.edit()
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("Experience", {
                                        ref: "experienceFunctionTaxField",
                                        attrs: {
                                          "initial-data":
                                            _vm.experienceFunctionTaxField,
                                          meta: _vm.meta,
                                          "characteristic-items":
                                            _vm.meta.functionTaxField,
                                          "characteristic-type":
                                            _vm.meta.functionTaxFieldType,
                                          title:
                                            "Hast du mit bestimmten Steuergebieten Erfahrung gesammelt?",
                                          "nothing-overall-text":
                                            "Ich habe noch keine Vorerfahrung",
                                          "experience-none-allowed": "",
                                          "with-keyword": false,
                                          "with-edit-button": false,
                                          "completion-check-config": {
                                            label: "Steuergebiete - Erfahrung",
                                            infoLabel:
                                              "Steuergebiets-Erfahrungen",
                                            okButtonText:
                                              "Keine weitere Steuergebietserfahrung"
                                          }
                                        },
                                        on: {
                                          finish: function($event) {
                                            return _vm.saveExperience(
                                              $event,
                                              false,
                                              "experienceFunctionTaxField",
                                              _vm.sections
                                                .experienceFunctionTaxField
                                            )
                                          }
                                        },
                                        model: {
                                          value: _vm.experienceFunctionTaxField,
                                          callback: function($$v) {
                                            _vm.experienceFunctionTaxField = $$v
                                          },
                                          expression:
                                            "experienceFunctionTaxField"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isSectionEligible(
                                _vm.sections.experienceFunctionTaxRole
                              )
                                ? _c(
                                    "section",
                                    [
                                      _c("Title", {
                                        attrs: {
                                          title:
                                            "Steuertätigkeiten - Erfahrung",
                                          parent: "",
                                          "completion-type": _vm.getSectionCompletionType(
                                            _vm.sections
                                              .experienceFunctionTaxRole
                                          )
                                        },
                                        on: {
                                          edit: function($event) {
                                            return _vm.$refs.experienceFunctionTaxRole.edit()
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("Experience", {
                                        ref: "experienceFunctionTaxRole",
                                        attrs: {
                                          "initial-data":
                                            _vm.experienceFunctionTaxRole,
                                          meta: _vm.meta,
                                          "characteristic-items":
                                            _vm.meta.functionTaxRole,
                                          "characteristic-type":
                                            _vm.meta.functionTaxRoleType,
                                          title:
                                            "Hast du mit bestimmten Steuertätigkeiten Erfahrung gesammelt?",
                                          "nothing-overall-text":
                                            "Ich habe noch keine Vorerfahrung",
                                          "with-experience": true,
                                          "with-keyword": false,
                                          "with-edit-button": false,
                                          "completion-check-config": {
                                            label:
                                              "Steuertätigkeiten - Erfahrung",
                                            infoLabel:
                                              "Steuertätigkeits-Erfahrungen",
                                            okButtonText:
                                              "Keine weitere Steuertätigkeitserfahrung"
                                          }
                                        },
                                        on: {
                                          finish: function($event) {
                                            return _vm.saveExperience(
                                              $event,
                                              false,
                                              "experienceFunctionTaxRole",
                                              _vm.sections
                                                .experienceFunctionTaxRole
                                            )
                                          }
                                        },
                                        model: {
                                          value: _vm.experienceFunctionTaxRole,
                                          callback: function($$v) {
                                            _vm.experienceFunctionTaxRole = $$v
                                          },
                                          expression:
                                            "experienceFunctionTaxRole"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isSectionEligible(_vm.sections.drivingLicense)
                                ? _c(
                                    "section",
                                    [
                                      _c("Title", {
                                        attrs: {
                                          title: "Führerscheine",
                                          "completion-type": _vm.getSectionCompletionType(
                                            _vm.sections.drivingLicense
                                          ),
                                          parent: ""
                                        },
                                        on: {
                                          edit: function($event) {
                                            return _vm.$refs.drivingLicense.openFan()
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("CharacteristicEdit", {
                                        ref: "drivingLicense",
                                        class: {
                                          inline: _vm.hasNoDrivingLicenses
                                        },
                                        attrs: {
                                          title: "Führerscheine",
                                          "characteristic-items":
                                            _vm.meta.drivingLicenseClass,
                                          "characteristic-type":
                                            _vm.meta.drivingLicenseClassType,
                                          "nothing-allowed": {
                                            onlyOverall: true,
                                            overall: {
                                              text:
                                                "Ich habe keinen Führerschein",
                                              inFan: true
                                            }
                                          },
                                          "icon-path":
                                            "/img/characteristic/driving-license",
                                          "description-config": {
                                            inline: true
                                          },
                                          "with-edit-button": false,
                                          "completion-check-config": {
                                            enabled: true,
                                            label: "Führerscheine",
                                            okButtonText:
                                              "Keine weiteren Führerscheine",
                                            popUpInfo:
                                              _vm.completionCheckInfos
                                                .drivingLicense
                                          }
                                        },
                                        on: { finish: _vm.saveDrivingLicenses },
                                        model: {
                                          value: _vm.drivingLicense,
                                          callback: function($$v) {
                                            _vm.drivingLicense = $$v
                                          },
                                          expression: "drivingLicense"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isSectionEligible(_vm.sections.pilotLicense)
                                ? _c(
                                    "section",
                                    [
                                      _c("Title", {
                                        attrs: {
                                          title: "Flugscheine",
                                          "completion-type": _vm.getSectionCompletionType(
                                            _vm.sections.pilotLicense
                                          ),
                                          parent: ""
                                        },
                                        on: {
                                          edit: function($event) {
                                            return _vm.$refs.pilotLicense.openFan()
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("CharacteristicEdit", {
                                        ref: "pilotLicense",
                                        class: {
                                          inline: _vm.hasNoPilotLicenses
                                        },
                                        attrs: {
                                          title: "Flugscheine",
                                          "characteristic-items":
                                            _vm.meta.pilotLicense,
                                          "characteristic-type":
                                            _vm.meta.pilotLicenseType,
                                          "nothing-allowed": {
                                            onlyOverall: true,
                                            overall: {
                                              text:
                                                "Ich habe keinen Flugschein",
                                              inFan: true
                                            }
                                          },
                                          "with-edit-button": false,
                                          "completion-check-config": {
                                            enabled: true,
                                            label: "Flugscheine",
                                            okButtonText:
                                              "Keine weiteren Flugscheine",
                                            popUpInfo:
                                              _vm.completionCheckInfos
                                                .pilotLicense
                                          }
                                        },
                                        on: { finish: _vm.savePilotLicenses },
                                        model: {
                                          value: _vm.pilotLicense,
                                          callback: function($$v) {
                                            _vm.pilotLicense = $$v
                                          },
                                          expression: "pilotLicense"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }